 
import CallPanel from ".";
import { useCall } from "../../../hooks/useCallSocket";

const CallModule = () => {
  const { incomingCall, acceptCall, declineCall, closeCall } = useCall();

  if (!incomingCall?.isOpen) return null;

  return (
    <CallPanel
      isOpen={incomingCall.isOpen}
      callerPhone={incomingCall.callerPhone}
      callData={incomingCall.callData}
      onAccept={acceptCall}
      onDecline={declineCall}
      onClose={closeCall}
    />
  );
};

export default CallModule;
